// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__hZohQ","spinner":"styles_spinner__w3QeH","spin":"styles_spin__aJENk"};